import React from "react";
import styled from "styled-components/macro";
import { CircularProgress, Typography } from "@material-ui/core";

const Wrapper = styled.div`
  min-height: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #475569;
`;

function AppLoadingScreen({ message = "Cargando su espacio de trabajo..." }) {
  return (
    <Wrapper role="status" aria-live="polite">
      <CircularProgress size={38} thickness={4} />
      <Typography variant="body1">{message}</Typography>
    </Wrapper>
  );
}

export default AppLoadingScreen;
